import { render, staticRenderFns } from "./CustomerList.vue?vue&type=template&id=3d7ead4d&scoped=true&"
import script from "./CustomerList.vue?vue&type=script&lang=js&"
export * from "./CustomerList.vue?vue&type=script&lang=js&"
import style0 from "./CustomerList.vue?vue&type=style&index=0&id=3d7ead4d&prod&lang=less&"
import style1 from "./CustomerList.vue?vue&type=style&index=1&id=3d7ead4d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7ead4d",
  null
  
)

export default component.exports